import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../../../hooks/useAuth'

import styles from './addInstitution.module.scss'

import { Institution } from '@/domain/entities/institution.entity'
import { InstitutionRepository } from '../../../repositories/institution.repository'

export function AddInstitutionPage() {
  const { token } = useAuth()
  const navigate = useNavigate()

  const [image, setImage] = useState<File>()
  const [institution, setInstitution] = useState({
    active: true,
  } as Institution)

  async function addInstitution() {
    if (!image) return

    const _institution = await InstitutionRepository.GetInstance().adminCreate(
      token,
      institution,
    )

    await updateImagem(_institution.id)
    navigate('/institution/' + _institution.id)
  }

  async function updateImagem(id: string) {
    const _institution = await InstitutionRepository.GetInstance().uploadImage(
      token,
      id,
      image,
    )
    setInstitution(_institution)
  }

  return (
    <div className={styles.unit}>
      <h1>Nova Instituição</h1>
      <input
        onChange={(e) =>
          setInstitution({ ...institution, title: e.target.value })
        }
        placeholder="título"
        value={institution.title}
      />
      <input
        onChange={(e) =>
          setInstitution({ ...institution, email: e.target.value })
        }
        placeholder="email"
        value={institution.email}
      />
      <input
        onChange={(e) =>
          setInstitution({ ...institution, password: e.target.value })
        }
        placeholder="senha"
        value={institution.password}
      />
      <input
        onChange={(e) =>
          setInstitution({ ...institution, bairro: e.target.value })
        }
        placeholder="bairro"
        value={institution.bairro}
      />
      <input
        onChange={(e) =>
          setInstitution({ ...institution, cidade: e.target.value })
        }
        placeholder="cidade"
        value={institution.cidade}
      />
      <input
        onChange={(e) =>
          setInstitution({ ...institution, description: e.target.value })
        }
        placeholder="descrições"
        value={institution.description}
      />
      <input
        onChange={(e) =>
          setInstitution({ ...institution, active: e.target.value === 'Ativo' })
        }
        placeholder="descrições"
        value={'Ativo'}
      />
      <input onChange={(e) => setImage(e.target.files[0])} type="file" />
      <button onClick={addInstitution}>Adicionar Instituição</button>
      <div className={styles.unit} />
    </div>
  )
}
